import { render, staticRenderFns } from "./ButtonAddFixed.vue?vue&type=template&id=7a480582&scoped=true"
import script from "./ButtonAddFixed.vue?vue&type=script&lang=js"
export * from "./ButtonAddFixed.vue?vue&type=script&lang=js"
import style0 from "./ButtonAddFixed.vue?vue&type=style&index=0&id=7a480582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a480582",
  null
  
)

export default component.exports